import {
  signInWithEmailAndPassword,
  sendEmailVerification,
  signOut as firebaseSignOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from './config';

// ─── Error helper ─────────────────────────────────────────────────────────────

export function friendlyAuthError(e) {
  const map = {
    'auth/email-already-in-use':  'An account with that email already exists.',
    'auth/invalid-email':          'That doesn\'t look like a valid email address.',
    'auth/user-not-found':         'No account found with that email.',
    'auth/wrong-password':         'Incorrect password.',
    'auth/invalid-credential':     'Incorrect email or password.',
    'auth/weak-password':          'Password must be at least 6 characters.',
    'auth/too-many-requests':      'Too many attempts. Please wait a few minutes.',
    'auth/network-request-failed': 'Network error. Check your connection.',
    'auth/user-disabled':          'This account has been disabled.',
  };
  return map[e?.code] ?? (e.message ?? 'Something went wrong. Please try again.');
}

// ─── Admin sign-in ────────────────────────────────────────────────────────────

export async function adminSignIn(email, password) {
  const credential = await signInWithEmailAndPassword(auth, email, password);
  const user = credential.user;

  if (!user.emailVerified) {
    await firebaseSignOut(auth);
    throw new Error('Please verify your email before signing in.');
  }

  const adminSnap = await getDoc(doc(db, 'admins', user.uid));
  if (!adminSnap.exists()) {
    await firebaseSignOut(auth);
    throw new Error('This account does not have admin access.');
  }

  return { uid: user.uid, email: user.email, ...adminSnap.data() };
}

export async function adminSignOut() {
  await firebaseSignOut(auth);
}

export function onAdminAuthStateChanged(callback) {
  return onAuthStateChanged(auth, async (user) => {
    if (!user || !user.emailVerified) { callback(null); return; }
    const snap = await getDoc(doc(db, 'admins', user.uid));
    callback(snap.exists() ? { uid: user.uid, email: user.email, ...snap.data() } : null);
  });
}

export async function sendAdminVerificationEmail(user) {
  await sendEmailVerification(user);
}
